import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';

export default function StockTransferIdDialog({ stockTransferId, open, handleClose, onDone }) {
    const classes = useStyles();

    return (
        <div>
            <Dialog
                disableEscapeKeyDown={true}
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogTitle style={{ paddingLeft: '0px' }} id="alert-dialog-title">
                        {'Stock Transfer Complete'}
                    </DialogTitle>
                    <DialogContentText id="alert-dialog-description">
                        Stock Transferred out successfully. Stock Transfer Reference Number: <br />{' '}
                        <strong>{stockTransferId}</strong>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Grid container direction="row" justifyContent="flex-end" alignItems="center">
                        <Button
                            key="next"
                            variant="contained"
                            color="primary"
                            onClick={onDone}
                            className={classes.doneButton}
                        >
                            OK
                        </Button>
                    </Grid>
                </DialogActions>
            </Dialog>
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    actions: {
        padding: 0,
    },
    s: {
        marginRight: '24px',
    },
    doubleCheckButton: {
        width: '300px',
        fontSize: '15px',
        color: 'grey',
    },
    doneButton: {
        width: '100px',
        height: '7%',
        // fontSize: '30px',
        justifyContent: 'center',
        alignSelf: 'center',
    },
    subheading: {
        fontSize: '26px',
        marginBottom: theme.spacing(2),
    },
}));
